import React from "react";

import { Plus } from "lucide-react";
import { useHistory } from "react-router-dom";

import { Button } from "@/src/components/ui/button";

import type { JSX } from "react";

interface CreateButtonProps {
  label: string;
  href: string;
  disabled?: boolean;
}

function CreateButton({
  label,
  href,
  disabled,
}: CreateButtonProps): JSX.Element {
  const history = useHistory();

  return (
    <Button
      disabled={disabled}
      onClick={() => history.push(href)}
      size="lg"
      type="button"
    >
      <Plus />
      {label}
    </Button>
  );
}

export default CreateButton;
